var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42018 0.890625C4.70187 0.890625 0.880859 4.61111 0.880859 9.20528C0.880859 12.8852 3.32591 15.9918 6.71995 17.0945C7.14692 17.1675 7.30703 16.9175 7.30703 16.6998C7.30703 16.5017 7.29703 15.8473 7.29703 15.1506C5.15219 15.5355 4.5968 14.6407 4.42501 14.173C4.32828 13.9342 3.91299 13.1953 3.5494 12.9988C3.25085 12.8429 2.82389 12.4581 3.53939 12.4483C4.21153 12.4386 4.69187 13.0508 4.85198 13.3009C5.62085 14.5578 6.84838 14.2054 7.33872 13.9862C7.41377 13.4454 7.63726 13.0817 7.88244 12.8738C5.98277 12.6659 3.99638 11.9481 3.99638 8.76844C3.99638 7.86389 4.32661 7.11525 4.87199 6.53387C4.78693 6.32601 4.48839 5.47343 4.95705 4.33016C4.95705 4.33016 5.67255 4.11255 7.30537 5.18274C7.98918 4.99599 8.71469 4.9018 9.4402 4.9018C10.1657 4.9018 10.8912 4.99599 11.575 5.18274C13.2078 4.10119 13.9233 4.33016 13.9233 4.33016C14.3937 5.47343 14.0935 6.32601 14.0084 6.53387C14.5521 7.11525 14.884 7.85415 14.884 8.76844C14.884 11.9595 12.8876 12.6659 10.9879 12.8738C11.2982 13.1336 11.565 13.6322 11.565 14.4117C11.565 15.5241 11.555 16.4173 11.555 16.6982C11.555 16.9158 11.7151 17.1757 12.1421 17.0928C15.5145 15.9918 17.9595 12.8738 17.9595 9.20528C17.9595 4.61111 14.1385 0.890625 9.42018 0.890625Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.4bb9d93357d671908c078c5d710c40a1.svg";
export { ForwardRef as ReactComponent };